import styled from "styled-components";
import { Typography } from "@dealer-center/core-components";
import { Locale } from "@dealer-center/ddc-core-utils";
import { formatCurrency } from "../utils/format";

const TotalContainer = styled.div<{ disabled?: boolean }>`
  margin-top: 20px;
  padding: 14px 20px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  display: grid;
  grid-template-columns: 100px 1fr 1fr 220px 150px 20px;
  gap: 8px;
  align-items: center;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  transition: opacity 0.2s;

  @media (max-width: 768px) {
    min-width: 490px;
  }
`;

const EmptyCell = styled.div``;

const LabelCell = styled.div`
  text-align: left;
  margin-left: -10px;
`;

const SubLabel = styled.div`
  font-size: 12px;
  color: #4b5563;
  margin-top: 2px;
`;

const AmountCell = styled.div`
  display: flex;
  align-items: center;
  margin-left: 0px;
`;

export interface TotalFeesDisplayProps {
  total: number;
  vehicleType: "new" | "preowned";
  disabled?: boolean;
  locale?: string;
}

export const TotalFeesDisplay = ({
  total,
  vehicleType,
  disabled,
  locale = "en-US"
}: TotalFeesDisplayProps) => {
  const typeLabel = Locale.getText(
    vehicleType === "new"
      ? "FEEMANAGER_NEW_TOTALFEES"
      : "FEEMANAGER_PREOWNED_TOTALFEES"
  );

  return (
    <TotalContainer disabled={disabled}>
      {/* Empty cells for Selected and Name columns */}
      <EmptyCell />
      <EmptyCell />
      <EmptyCell />

      {/* Label in Include column */}
      <LabelCell>
        <Typography variant={"body-sm"}>{typeLabel}</Typography>
        <SubLabel>
          {String(Locale.getText("FEEMANAGER_INCLUDEFEESONLY"))}
        </SubLabel>
      </LabelCell>

      {/* Total amount in Amount column */}
      <AmountCell>
        <Typography variant={"h3"}>{formatCurrency(total, locale)}</Typography>
      </AmountCell>

      {/* Empty cell for Right spacing column */}
      <EmptyCell />
    </TotalContainer>
  );
};
